import React , {useContext} from 'react';
import { Context } from './index';
import { Navigate, Route,Routes } from 'react-router-dom';
const PrivateRoute = ({ children: Children, ...rest }) => {
    const { store } = useContext(Context);
    const show = store.checkShow();
    return (
        <Routes>


            <Route {...rest}>

                {show ? <Children /> : <Navigate to="/login" replace />}

            </Route>
        </Routes>
    );
};

export default PrivateRoute;